import { memo } from "react";

import dompurify from "isomorphic-dompurify";

const { sanitize } = dompurify;

export const TransactionLinkWidgetEntryPoint = memo(() => {
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: sanitize("<transactionlink-widget></transactionlink-widget>", {
          ALLOWED_TAGS: ["transactionlink-widget"],
        }),
      }}
    ></div>
  );
});
